'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../utils');

var _utils2 = require('../../../core/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WinresProductReview = function () {
    function WinresProductReview($scope, productService, localizationService) {
        _classCallCheck(this, WinresProductReview);

        this.$scope = $scope;
        this.productService = productService;
        this.reviews = [];
        this.localizationService = localizationService;
        this.status = 'waiting';
    }

    _createClass(WinresProductReview, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.data = this.winresReservationContext.getContext();

            this.$scope.$watch(function () {
                return _this.data.Destination;
            }, function (destination) {
                if (destination != null) {
                    _this.status = 'loading';
                    _this.fetchReviews(destination.DestinationCode, _this.winresReservationContext.getUrlParams().ProductCode);
                }
            });
        }
    }, {
        key: 'fetchReviews',
        value: function fetchReviews(destinationCode, productCode) {
            var _this2 = this;

            this.productService.getReservableProduct(destinationCode, productCode, this.localizationService.getLanguage()).then(function (product) {
                if (product) {
                    _this2.productService.getProductReview(destinationCode, product.DestinationInfo.ProductCode).then(function (reviews) {
                        if (!reviews || reviews.length === 0) {
                            _this2.status = 'error';
                        } else {
                            _this2.reviews = reviews;
                            _this2.getReviewStars();
                            _this2.getAverageStars();
                            _this2.status = 'success';
                        }
                    });
                } else {
                    console.warn('[WPR] Failed to load product reviews, product is', product);
                    _this2.status = 'error';
                }
            }).catch(function (error) {
                console.warn("[WPR] [fetchReviews] Failed to load product reviews. Error: ", error);
                _this2.status = 'error';
            });
        }
    }, {
        key: 'getReviewStars',
        value: function getReviewStars() {
            _.each(this.reviews, function (review) {
                review.Date = (0, _utils2.formatFinnishDatePretty)(review.Date);
                review.stars = _.concat(_.times(review.Stars, _.constant(1)), _.times(5 - review.Stars, _.constant(0)));
            });
        }
    }, {
        key: 'getAverageStars',
        value: function getAverageStars() {
            var sum = _.sumBy(this.reviews, function (review) {
                return review.Stars;
            });
            var average = sum / this.reviews.length;
            var round = Math.round(average);

            this.averageStars = _.concat(_.times(round, _.constant(1)), _.times(5 - round, _.constant(0)));

            // Round to closest 0.5
            var roundDecimalHalf = Math.round(average * 2) / 2;
            var ceil = Math.ceil(average);

            // Is decimal
            if (roundDecimalHalf % 1 != 0) {
                // Half star
                this.averageStars[ceil - 1] = 2;
            }

            var roundDecimal = Math.round(average * 10) / 10;

            this.averageStr = ('' + roundDecimal).replace('.', ',');
        }
    }]);

    return WinresProductReview;
}();

WinresProductReview.$inject = ['$scope', 'productService', 'localizationService'];

function getTemplate($attrs, $sce) {
    return $attrs.templateUrl ? $sce.trustAsResourceUrl((0, _utils.getWebcomponentsUrl)($attrs.templateUrl)) : 'winresProductReview';
}

getTemplate.$inject = ['$attrs', '$sce'];

_module3.default.run(['$templateCache', function ($templateCache) {
    $templateCache.put('winresProductReview', require('./winresProductReview.html'));
}]);

_module3.default.component('winresProductReview', {
    templateUrl: getTemplate,
    controller: WinresProductReview,
    require: {
        winresReservationContext: '^^winresReservationContext'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresProductReview/winresProductReview.js
// module id = 439
// module chunks = 2